export default [
    {
      path: '/goga-exam',
      component: () => import('./views/Index'),
      name: 'goga-exam',
      redirect: { name: 'goga-exam-list' },
      children: [
        {
          path: '',
          name: 'goga-exam-list',
          component: () => import('./views/List'),
          meta: {
            resource: 'content',
          },
        },
        {
            path: ':id',
            name: 'goga-exam-detail',
            component: () => import('./views/Detail'),
            meta: {
              resource: 'content',
            },
          },
      ],
    },
  ]
  